module.exports = __webpack_public_path__ + "static/media/Zapdos_gaussian2.ccc73b29.png";